export const lg_meeting_recording = {
  meeting_recording_th: {
    title: "บันทึกประชุม",
    search_conditions: "เงื่อนไขในการค้นหา",
    search_user: "ผู้สร้าง",
    search_topic: "ชื่อการประชุม",
    search_date: "วันที่",
    download:"ดาวน์โหลด",
    download_fail:"ดาวน์โหลดไม่สำเร็จ",
    unavailable:"ไม่พบไฟล์บันทึก",
    saved_successfully:"บันทึกเรียบร้อยแล้ว",
    failed:"ล้มเหลว",
    headers: [
      { text: "วัน / เวลา (UTC/GMT+7)", value: "started_time" },
      { text: "หัวข้อการประชุม", value: "meeting.title" },
      { text: "ระยะเวลา (นาที)", value: "recording_duration", sortable: false },
      { text: "ลิงก์", value: "action" },
       { text: "สถานะการบันทึก", value: "status" },
    ],
  },
  meeting_recording_en: {
    title: "Recording",
    search_conditions: "Search Conditions",
    search_user: "User",
    search_topic: "Meeting Name",
    search_date: "Date",
    download:"Download",
    download_fail:"Download Failed",
    unavailable:"Unavailable",
    saved_successfully:"Saved Successfully",
    failed:"Failed",
    headers: [
      { text: "Date / Time (UTC/GMT+7)", value: "started_time" },
      { text: "Meeting Title", value: "meeting.title" },
      { text: "Duration (min)", value: "recording_duration", sortable: false },
      { text: "Link", value: "action" },
       { text: "Recording Status", value: "status" },
    ],
  },
};
